import React from "react";

import { useDossierInscriptionSettings } from "./hooks/useDossierInscriptionSettings";

import DossierHeader from "./components/DossierHeader";
import DossierKpiCards from "./components/DossierKpiCards";
import DossierSegmentsShell from "./components/DossierSegmentsShell";
import SegmentCreateDrawer from "./components/SegmentCreateDrawer";

export default function SettingsDossierInscription() {
  const dashboard = useDossierInscriptionSettings();

  return (
    <div className="space-y-5">
      <DossierHeader
        loading={dashboard.loading}
        onRefresh={dashboard.fetchSegments}
        onCreate={dashboard.openCreateDrawer}
      />

      {/* <DossierKpiCards
        stats={dashboard.stats}
        loading={dashboard.loading}
      /> */}

      <DossierSegmentsShell
        segments={dashboard.segments}
        filteredSegments={dashboard.filteredSegments}
        activeSegment={dashboard.activeSegment}
        activeSegmentId={dashboard.activeSegmentId}
        setActiveSegmentId={dashboard.setActiveSegmentId}
        search={dashboard.search}
        setSearch={dashboard.setSearch}
        loading={dashboard.loading}
        savingSegmentId={dashboard.savingSegmentId}
        deletingSegmentId={dashboard.deletingSegmentId}
        fileForms={dashboard.fileForms}
        fileToEditId={dashboard.fileToEditId}
        savingFileId={dashboard.savingFileId}
        deletingFileId={dashboard.deletingFileId}
        onSegmentChange={dashboard.handleLocalSegmentChange}
        onSaveSegment={dashboard.handleSaveSegment}
        onDeleteSegment={dashboard.handleDeleteSegment}
        onFileChange={dashboard.handleFileChange}
        onEditFile={dashboard.handleEditFile}
        onResetFileForm={dashboard.resetFileForm}
        onSaveFile={dashboard.handleSaveFile}
        onDeleteFile={dashboard.handleDeleteFile}
        onCreate={dashboard.openCreateDrawer}
      />

      <SegmentCreateDrawer
        isOpen={dashboard.createDrawerOpen}
        submitting={dashboard.creatingSegment}
        newSegment={dashboard.newSegment}
        setNewSegment={dashboard.setNewSegment}
        newFormKey={dashboard.newFormKey}
        onClose={dashboard.closeCreateDrawer}
        onSubmit={dashboard.handleAddSegment}
        onReset={dashboard.resetNewSegment}
      />
    </div>
  );
}